import {isStackableOverlayNavigation} from './isStackableOverlayNavigation'
import type {RouteLocationNormalized} from 'vue-router'

export function shouldSkipWorkspaceResolution(
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  currentWorkspaceName: string|null|undefined,
): boolean {
  if(!isStackableOverlayNavigation(to, from)) {
    return false
  }

  return to.params.workspaceName === currentWorkspaceName
}
